export enum ProgramsMasterInstrumentsOrderingEnum {
  Name = 'Name',
  Type = 'Type',
}
